import styled from 'styled-components';
import { BrandedIllustrationDoor } from './illustrations/door.component';
import { BrandedIllustrationDevices } from './illustrations/devices.component';
import { BrandedIllustrationPhoneOngoing } from './illustrations/phone_ongoing.component';
import { BrandedIllustrationDisconnected } from './illustrations/disconnected.component';

const Container = styled.div`
	svg {
		width: 100%;
		height: 100%;
		display: block;
		pointer-events: none;
		fill: currentColor;
		stroke: currentColor;
		flex-shrink: 0;
	}
`;

type BrandedIllustrations = {
	door: string;
	devices: string;
	phoneOngoing: string;
	disconnected: string;
};

export type BrandedIllustrationType = keyof BrandedIllustrations;

interface BrandedIllustrationProps {
	illustration: BrandedIllustrationType;
}

export function BrandedIllustration({ illustration }: BrandedIllustrationProps) {
	let illustrationComponent;

	switch (illustration) {
		case 'door':
			illustrationComponent = <BrandedIllustrationDoor />;
			break;
		case 'devices':
			illustrationComponent = <BrandedIllustrationDevices />;
			break;
		case 'phoneOngoing':
			illustrationComponent = <BrandedIllustrationPhoneOngoing />;
			break;
		case 'disconnected':
			illustrationComponent = <BrandedIllustrationDisconnected />;
			break;
	}

	return <Container>{illustrationComponent}</Container>;
}
